@if (listForm) {
  <div class="form-group" [formGroup]="listForm">
    <div class="fields-group">
      <div>
        <div class="add-item-input-group">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          <div class="input-autocomplete-container">
            <input #autocompleteField  class="form-control add-item-input" name="new-item" formControlName="new_item" autocomplete="off" [attr.disabled]="listAtLimit() ? true : null" />
          </div>
          <button class="btn btn-primary" type="button" (click)="addItem(item)" [attr.disabled]="listAtLimit() ? true : null">ADD</button>
        </div>
        @if (isDuplicateItem(newItemCtl.value)) {
          <p class="error-text">This tag is already in the group</p>
        }
        <div class="editable-list">
          @for (item of list; track item) {
            <div class="added-item clearfix">
              <span>{{item}}</span>
              @if (showRemove) {
                <i class="fa fa-minus-circle" aria-hidden="true" (click)="removeItem(item)"></i>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
